import backend from '@common/backend';

const BASE = '/lessonWorks';

export const updateLessonWork = async (lesson_work_id: number, data: any) => backend.put(`${BASE}/${lesson_work_id}`, data);

export const invertEnabledLessonWork = async (lesson_work_id: number) => backend.put(`${BASE}/invertEnabled/${lesson_work_id}`, {});
